export default __webpack_public_path__ + "static/Image_1-0465f1f40ef94464febc7ace06bb8f5e.jpg";